import script from "./TwoFactorNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorNotification.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorNotification.vue?vue&type=style&index=0&id=1ff9efe7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff9efe7"]])

export default __exports__